// The receipt's note and the email it came in. The note is what was typed
// (above a forward, or in a direct email with files); it can be changed, not
// removed — every earlier text stays in the history. The email is shown as
// text, never as items. Nothing kept (receipts from before Oct 2026) says so.
import { useEffect, useState } from 'react';

/** "Forwarded from The Home Depot <orders@…> · “Your order” · Sat, Oct 10" or null. */
export function forwardLine(fwd) {
  if (!fwd) return null;
  const who = fwd.fromName && fwd.from ? `${fwd.fromName} <${fwd.from}>` : fwd.fromName || fwd.from || 'an unknown sender';
  return [`Forwarded from ${who}`, fwd.subject ? `“${fwd.subject}”` : null, fwd.sentAt].filter(Boolean).join(' · ');
}

export function NotePanel({ note, busy, disabled, onSave }) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(note || '');
  useEffect(() => { if (!editing) setText(note || ''); }, [note, editing]);
  const clean = text.trim();
  const save = async () => { if (await onSave(clean)) setEditing(false); };
  return (
    <div className="rc-panel rc-panel--beige rc-notebox" aria-label="Note">
      <div className="rc-notebox-head">
        <h3 className="fin-section-title" style={{ margin: 0 }}>Note</h3>
        {!editing && !disabled && <button type="button" className="rc-btn rc-btn--small" onClick={() => setEditing(true)}>{note ? 'Edit' : 'Add a note'}</button>}
      </div>
      {editing ? (
        <>
          <textarea className="rc-input rc-notebox-text" rows={4} maxLength={2000} value={text} onChange={(e) => setText(e.target.value)} aria-label="Note text" autoFocus />
          <div className="rc-actions" style={{ marginBottom: 0 }}>
            <button type="button" className="rc-btn rc-btn--primary rc-btn--small" disabled={busy || !clean || clean === (note || '')} onClick={save}>Save</button>
            <button type="button" className="rc-btn rc-btn--small" disabled={busy} onClick={() => { setEditing(false); setText(note || ''); }}>Cancel</button>
          </div>
          <p className="rc-note" style={{ marginBottom: 0 }}>{note ? 'A note can be changed, not removed. The earlier text stays in the history.' : 'What it was for, the job, who it was with. Search finds it.'}</p>
        </>
      ) : (
        <p className="rc-notebox-body">{note || <span className="rc-note">No note.</span>}</p>
      )}
    </div>
  );
}

export function EmailPanel({ email }) {
  if (!email) return null;
  const fwd = forwardLine(email.forward);
  return (
    <div className="rc-emailbox">
      {fwd && <div className="rc-emailbox-fwd">{fwd}</div>}
      {email.text
        ? (
          <details>
            <summary>Email text</summary>
            <pre className="rc-emailbox-text">{email.text}</pre>
          </details>
        )
        : <div className="rc-note" style={{ margin: 0 }}>Email text not kept for this receipt.</div>}
    </div>
  );
}
